import { Icon } from '@tkww/orion-web-ds-graphic';
import { Body2 } from '@xo-union/tk-ui-typography';
import { useAtomValue } from 'jotai';
import React, { useMemo } from 'react';
import { pricingDetailsAtom } from '../../../jotai/storefront/pricing';
import Styles from './PricingDetails.scss';

const baseText =
	"Starting prices don't include service fees, taxes, gratuity, and rental fees. Guest count and seasonality may also affect prices.";
export const DisclaimerText = () => {
	const { peakMonths } = useAtomValue(pricingDetailsAtom);
	const text = useMemo(() => {
		if (!peakMonths) {
			return baseText;
		}

		return `${baseText} Peak season for this venue is ${peakMonths}.`;
	}, [peakMonths]);

	return (
		<div className={Styles.disclaimer}>
			<div>
				<Icon name="info" size="sm" aria-label="Information" />
			</div>
			<div>
				<Body2>{text}</Body2>
			</div>
		</div>
	);
};
